var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgOffsiteOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40860_3282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18C12 21.3137 14.6863 24 18 24ZM15.8451 21L19.8048 17.0403V19.9135H21V15H16.4185V16.1952H18.9597L15 20.1549L15.8451 21Z",
    fill: "var(--primary-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9913 12.4601C23.9971 12.3074 24 12.1541 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.1541 24 12.3075 23.9971 12.4602 23.9913C11.8796 23.4542 11.3772 22.8337 10.972 22.1488C10.3094 22.0825 9.66542 21.9528 9.04632 21.7658V19.5444H9.98602C9.89023 19.0443 9.84009 18.528 9.84009 18C9.84009 17.9208 9.84122 17.8418 9.84346 17.7631H7.26506V21.0367C7.17583 20.9899 7.08737 20.9418 6.99972 20.8924C4.44834 19.4305 2.59532 16.8884 2.06265 13.8912L7.55943 13.8912C8.67315 13.8912 9.59196 14.2529 10.4013 15.0201C10.6265 14.4464 10.9147 13.9044 11.2575 13.4026C10.199 12.5408 8.96632 12.1099 7.55943 12.1099L1.80058 12.11C1.80019 12.0733 1.8 12.0367 1.8 12C1.8 6.3667 6.3667 1.8 12 1.8C12.6147 1.8 13.2166 1.85437 13.8014 1.95856C13.6051 2.32533 13.507 2.73536 13.507 3.18865H12.0201C11.2033 3.18964 10.5035 3.48107 9.92061 4.06293C9.33775 4.6448 9.04632 5.34463 9.04632 6.16241V9.13618H14.9939V10.4116C15.5594 10.1874 16.1559 10.0246 16.7751 9.93136L16.7751 7.35493H10.8276V6.16241C10.8276 5.82133 10.9282 5.57394 11.1791 5.32354C11.4314 5.07166 11.6805 4.9705 12.0213 4.96989H15.2883V3.18865C15.2883 2.96328 15.3423 2.83028 15.4205 2.72113C15.4476 2.68331 15.4754 2.64681 15.5039 2.6116C19.0179 3.90078 21.6173 7.08639 22.0653 10.9231C22.7833 11.3365 23.4324 11.8559 23.9913 12.4601Z",
    fill: "var(--primary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40860_3282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffsiteOutlined);
export default __webpack_public_path__ + "static/media/offsiteOutlined.8a594c1b934662c8d7d157c198cf5747.svg";
export { ForwardRef as ReactComponent };